<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>CONTENTS</b></p>
<p class="toc1"><a href="#/Text/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/preface">Preface</a></p>
<p class="toc1"><a href="#/Text/chapter01">1. Mental Healthcare in the Quaker City: The Origins of Byberry</a></p>
<p class="toc"><span href="#/Text/chapter02" title="Link target outside of Sample">2. The Blockley Colony at Byberry Farms: Philly’s Funny Farm</span></p>
<p class="toc"><span href="#/Text/chapter03" title="Link target outside of Sample">3. Building Bedlam: The Crooked Construction Process</span></p>
<p class="toc"><span href="#/Text/chapter04" title="Link target outside of Sample">4. The Philadelphia Hospital for Mental Diseases: The City Years</span></p>
<p class="toc"><span href="#/Text/chapter05" title="Link target outside of Sample">5. The Philadelphia State Hospital: The State Years</span></p>
<p class="toc"><span href="#/Text/chapter06" title="Link target outside of Sample">6. The New Approach: Deinstitutionalization at Byberry</span></p>
<p class="toc"><span href="#/Text/chapter07" title="Link target outside of Sample">7. The End of an Era: The Closure of PSH</span></p>
<p class="toc"><span href="#/Text/chapter08" title="Link target outside of Sample">8. The Rediscovery of a Discarded Past: The Years of Abandon</span></p>
<p class="toc1"><span href="#/Text/source" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4c4b3db5